import React from 'react'
import { canEditPrefilledMainField } from './prefillPreviewUtils'

interface Props {
  element: any
  onDirectEdit: (fieldId: number) => void
}

const PreviewPrefillLabelExtras: React.FC<Props> = ({ element, onDirectEdit }) => {
  if (!element?.isPrefilled) return null

  const showEditButton = canEditPrefilledMainField(element) && element.prefillLocked

  return (
    <>
      <span className='badge bg-info readonly-form-preview__prefill-badge'>Pre-filled</span>
      {showEditButton && (
        <button
          type='button'
          className='btn btn-sm btn-link p-0 ms-1 align-baseline'
          title='Edit prefilled value'
          aria-label='Edit prefilled value'
          onClick={() => onDirectEdit(element.fieldId)}
        >
          <i className='bi bi-pencil-square' />
        </button>
      )}
    </>
  )
}

export default PreviewPrefillLabelExtras
